import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { StatusPill } from "@/components/StatusPill";

export default function ProfessionalTimesheets() {
  const [timesheets, setTimesheets] = useState([]);
  useEffect(() => { api.get("/timesheets").then((r) => setTimesheets(r.data)); }, []);

  const totalPay = timesheets
    .filter((t) => t.status === "admin_approved")
    .reduce((s, t) => s + t.total_pay, 0);

  return (
    <div className="space-y-4" data-testid="pro-timesheets-page">
      <h1 className="text-2xl font-bold text-brand-navy" style={{ fontFamily: "Outfit, sans-serif" }}>Timesheets & Earnings</h1>
      <Card className="bg-brand-teal text-white border-0">
        <CardContent className="p-5">
          <div className="text-xs uppercase tracking-wider text-white/70 font-semibold">Total earned (approved)</div>
          <div className="text-3xl font-bold mt-1" style={{ fontFamily: "Outfit, sans-serif" }}>${totalPay.toFixed(2)}</div>
          <div className="text-xs text-white/70 mt-1">{timesheets.length} timesheet{timesheets.length === 1 ? "" : "s"} on file</div>
        </CardContent>
      </Card>
      {timesheets.map((t) => (
        <Card key={t.id} data-testid={`ts-${t.id}`}>
          <CardContent className="p-4">
            <div className="flex items-start justify-between">
              <div>
                <div className="font-semibold text-slate-900">{t.facility?.name}</div>
                <div className="text-xs text-slate-500">{t.shift_date}</div>
              </div>
              <StatusPill status={t.status} />
            </div>
            <div className="mt-3 grid grid-cols-3 gap-2 text-xs">
              <div><div className="text-slate-500">Hours</div><div className="font-bold">{t.hours_worked}h</div></div>
              <div><div className="text-slate-500">Rate</div><div className="font-bold">${t.hourly_rate}</div></div>
              <div><div className="text-slate-500">Pay</div><div className="font-bold text-brand-navy">${t.total_pay.toFixed(2)}</div></div>
            </div>
          </CardContent>
        </Card>
      ))}
      {timesheets.length === 0 && <div className="text-center text-sm text-slate-500 py-12">No timesheets yet</div>}
    </div>
  );
}
